/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Table, Skeleton, Empty, Spin, Badge } from "antd";
import { onShowSizeChange, itemRender } from "../Pagination";
import { Link } from "react-router-dom";
import Select from "react-select";
import FeatherIcon from "feather-icons-react";
import styles from "./PatientsList.module.css";
import {
  getPatients,
  getPatientsFilters,
  getNeighborhoods,
} from "../../services/patient";
import { Avatar1, Avatar2, dotmenu, editarperfil } from "../imagepath";
import RegisterPatient from "./RegisterPatient";
import {patientStatusCode as statusCodes} from "../../utils/enums/statusCodes";

const PatientsList = () => {
  const [loading, setLoading] = useState(true);
  const [advanceMode, setAdvanceMode] = useState(false);

  const [filters, setFilters] = useState({
    states: [],
    risks: [],
    managers: [],
    pss: [],
  });

  //Filters value

  const [searchText, setSearchText] = useState("");
  const [state, setState] = useState([]);
  const [allState, setAllState] = useState([]);
  const [risk, setRisk] = useState([]);
  const [manager, setManager] = useState([]);
  //Patients list
  const [datasource, setDatasource] = useState([]);
  //Register Affilate Modal
  const [options, setOptions] = useState([]);
  const [IsModalOpen, setIsModalOpen] = useState(false);
  const [patientModal, setPatientModal] = useState({
    InsuredMember: "",
    name: "",
    email: "",
    telephone: "",
    address: "",
    manager: "",
    pathology: "",
    pathologyId: "",
    currentPathology: "",
    dateOfBirth: "",
    age: "",
    pss: {},
    pssId: "",
    municipality: {},
    municipalityId: "",
    neighboordhood: "",
    DemograficCd: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  //Functions
  const onClickAdvanceMode = () => {
    setAdvanceMode(!advanceMode);
  };
  const searchTextHandle = (event) => {
    setSearchText(event.target.value);
  };
  const onChangePage = (page, pageSize) => {
    setLoading(true);
    getPatientsList(page, pageSize);
    //Set current page for pagination
    setCurrentPage(page);
    setLoading(false);
  };
  const onSearch = async () => {
    setLoading(true);
    await getPatientsList(1, 10);
    setLoading(false);
  };
  // Get Patients
  const getPatientsList = async (pageIndex, pageSize) => {
    setDatasource([]);

    //Replace searchText "-" to "
    let searchTextReplace =
      searchText != undefined ? searchText.replaceAll("-", "") : searchText;
    const response = await getPatients({
      searchText: searchTextReplace,
      status: state && state.value != 0 ? state.value : null,
      risk: risk && risk.value != 0 ? risk.value : null,
      manager: manager
        ? //Get all values from manager and join by comma
          manager.map((manager) => manager.value).join(",")
        : null,
      pageIndex: pageIndex,
      pageSize: pageSize,
    });
    setDatasource(response);
  };

  const onClickRegisterPatient = (record) => {
    if (
      record.datosDemograficos != undefined &&
      record.datosDemograficos.municipioCd != undefined
    ) {
      getNeighborhoods(record.datosDemograficos.municipioCd).then((data) => {
        const neighboordhoods = data.map((item) => ({
          value: item.key,
          label: item.value,
        }));

        setOptions({
          ...options,
          neighboordhoods: neighboordhoods,
        });

        setPatientModal({
          InsuredMember: record.id,
          name: record.fullName,
          email: record.email,
          //Set Format Phone in (xxx) xxx-xxxx
          telephone: record.phone.replace(
            /(\d{3})(\d{3})(\d{4})/,
            "($1) $2-$3"
          ),
          address: "",
          manager: record.manager,
          managerId: record.managerCd,
          pathologyId: record.pathologyCd,
          currentPathology: record.pathology,
          dateOfBirth: record.dateOfBirth,
          age: record.age,

          address: record.datosDemograficos.direccion,
          municipalityId:
            record.datosDemograficos != undefined
              ? record.datosDemograficos.municipioCd
              : "",
          neighborhoodId:
            record.datosDemograficos != undefined
              ? record.datosDemograficos.datoDemograficoCd
              : "",
        });
        setIsModalOpen(true);
      });
    } else {
      setPatientModal({
        InsuredMember: record.id,
        name: record.fullName,
        email: record.email,
        //Set Format Phone in (xxx) xxx-xxxx
        telephone: record.phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3"),
        address: "",
        manager: record.manager,
        managerId: record.managerCd,
        pathologyId: record.pathologyCd,
        currentPathology: record.pathology,
        dateOfBirth: record.dateOfBirth,
        age: record.age,
        address: undefined,
        municipalityId:
          record.datosDemograficos != undefined
            ? record.datosDemograficos.municipioCd
            : undefined,
        neighborhoodId:
          record.datosDemograficos != undefined
            ? record.datosDemograficos.datoDemograficoCd
            : undefined,
        gender: record.gender,
      });
      setIsModalOpen(true);
    }
  };

  const onCloseModal = () => {
    setIsModalOpen(false);
  };

  const OnCompleteModal = async () => {
    setIsModalOpen(false);
    setLoading(true);
    await getPatientsList(currentPage, 10);
    setLoading(false);
  };

  // UseEffect for fetch data
  React.useEffect(() => {
    setLoading(true);
    getFiltersOptions();
    getPatientsList(1, 10).then(() => {
      setLoading(false);
    });
  }, []);

  // Get Filters Options
  const getFiltersOptions = async () => {
    await getPatientsFilters().then((response) => {
      const pathologies = response.pathologies.map((item) => ({
        value: item.key,
        label: item.value,
      }));

      const risks = response.risks.map((item) => ({
        value: item.key,
        label: item.value,
      }));

      const managers = response.managers.map((item) => ({
        value: item.key,
        label: item.value,
        pss: item.pss,
      }));

      const statesNoAllowed = [
        statusCodes.Enroll.value,
        statusCodes.Discard.value,
      ];
      //Mapping States to value and label
      const states = response.status.map((state) => {
        return {
          value: state.key,
          label: state.value,
        };
      });
      const pss = response.pss.map((item) => ({
        value: item.key,
        label: item.value,
      }));

      const municipalities = response.municipios.map((item) => ({
        value: item.key,
        label: item.value,
      }));

      const generos = response.generos.map((item) => ({
        value: item.key,
        label: item.value,
      }));
      //Add filter default value empty for states, riks
      states.unshift({ value: 0, label: "Todos" });
      risks.unshift({ value: 0, label: "Todos" });
      setFilters({
        ...filters,
        pathologies: pathologies,
        risks: risks,
        managers: managers,
        states: states.filter((x) => !statesNoAllowed.includes(x.value)),
        pss: pss,
      });

      setOptions({
        managers: managers,
        pathologies: pathologies,
        pss: pss,
        municipalities: municipalities,
        genders: generos,
      });
    });
  };
  const columns = [
    {
      title: "Documento",
      dataIndex: "document",
      sorter: (a, b) => a.document.length - b.document.length,
      render: (text, record) => (
        <div key={"avatarDocumentId" + record.InsuredMember}>
          <h2 className="profile-image">
            {record.document.replace(/(\d{3})(\d{7})(\d{1})/, "$1-$2-$3")}
          </h2>
        </div>
      ),
    },
    {
      title: "Nombre",
      dataIndex: "fullName",
      sorter: (a, b) => a.fullName.length - b.fullName.length,
      render: (text, record) => (
        <div
          style={{ textWrap: "wrap" }}
          key={"avatarProfileName" + record.InsuredMember}
        >
          <h2 className="profile-image">
            <Link
              to="#"
              className="avatar avatar-sm me-2"
              key={"avatar" + record.InsuredMember}
            >
              <img
                width={28}
                height={28}
                className="rounded-circle"
                src={record.gender === "F" ? Avatar1 : Avatar2}
                alt="#"
              />
            </Link>
            <Link to="#" key={"linkProfile" + record.InsuredMember}>
              {record.fullName}
            </Link>
          </h2>
        </div>
      ),
    },
    //
    {
      title: "Edad",
      dataIndex: "age",
      sorter: (a, b) => a.age.length - b.age.length,
    },
    {
      title: "Teléfono",
      dataIndex: "phone",
      sorter: (a, b) => a.phone.length - b.phone.length,
      render: (text, record) => (
        <>
          {/* format record.Phone in (###)-###-#### */}
          <Link to="#" key={"phone" + record.InsuredMember}>
            {record.phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1)-$2-$3")}
          </Link>
        </>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (a, b) => a.status.length - b.status.length,
      render: (text, record) =>
        //Get Status code and get color from statusCodes from enum using record.statusCode
        Object.keys(statusCodes).map((key) => {
          if (statusCodes[key].value === record.statusCode) {
            return (
              <>
                {/* <span className="badge bg-success">{statusCodes[key].text}</span> */}
                <Badge
                  count={record.status}
                  color={statusCodes[key].color}
                  key={"badgeStatus" + key + "_" + record.InsuredMember}
                />
              </>
            );
          }
        }),
    },
    {
      title: "Riesgo",
      dataIndex: "risk",
      sorter: (a, b) => a.risk.length - b.risk.length,
      render: (text, record) => (
        <div key={"risk" + record.InsuredMember}>
          <FeatherIcon
            icon="info"
            color={
              record.risk === "A1"
                ? "red"
                : record.risk === "A2"
                  ? "#ffc107"
                  : "#28a745"
            }
          />
          &nbsp;
          {record.risk == "A1"
            ? "Alto"
            : record.risk == "A2"
              ? "Medio"
              : record.risk == ""
                ? ""
                : "Bajo"}
        </div>
      ),
    },
    {
      title: "Gestión",
      dataIndex: "management",
      width: "15%",
      sorter: (a, b) => a.management.length - b.management.length,
      render: (text, record) => (
        <div
          style={{ textWrap: "wrap" }}
          key={"gestion" + record.InsuredMember}
        >
          {record.management.split("\n")[0]}
          <br />
          {record.management.split("\n")[1]}
        </div>
      ),
    },
    {
      title: "Gestor",
      dataIndex: "manager",
      sorter: (a, b) => a.manager.length - b.manager.length,
      render: (text, record) => (
        <div style={{ textWrap: "wrap" }}>{record.manager}</div>
      ),
    },
    {
      title: "",
      dataIndex: "actions",
      render: (text, record) => (
        <>
          <div className="text-end">
            <div className="dropdown dropdown-action">
              <Link
                to="#"
                className="action-icon dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                key={"actions" + record.InsuredMember}
              >
                <img 
                width={12}
                height={12}
                className="fas"
                src={dotmenu} alt="" />
              </Link>
              <div className="dropdown-menu dropdown-menu-end">
                <Link
                  className="dropdown-item"
                  to={"/admin/patient/profile/" + record.id}
                  key={"actionProfile" + record.InsuredMember}
                >
                  <img 
                  width={12}
                  height={12}
                  className="far me-2"
                  src={editarperfil} alt=""/>
                  Perfil
                </Link>
                {record.statusCode === statusCodes.Affiliate.value && (
                  <Link
                    className="dropdown-item"
                    to="#"
                    onClick={() => {
                      onClickRegisterPatient(record);
                    }}
                    key={"actionRegister" + record.InsuredMember}
                  >
                    <img 
                    width={12}
                    height={12}
                    className="far me-2"
                    src={editarperfil} alt=""/>
                    Registrar
                  </Link>
                )}
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];
  return (
    <>
      {/* Page Header */}
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="#">Población Afiliada </Link>
              </li>
              <li className="breadcrumb-item">
                <i className="feather-chevron-right" />
              </li>
              <li className="breadcrumb-item active">Población Afiliada</li>
            </ul>
          </div>
        </div>
      </div>
      {/* End Page Header */}
      {/* Search Filters */}
      <div className="row">
        <div className="col-sm-12">
          <div className="card card-table show-entire">
            <div className="card-body">
              <div className="staff-search-table">
                {/* Basic Filters */}
                <div className="row">
                  <div className="col-12 col-md-6 col-xl-3">
                    <div className="form-group local-forms">
                      <label>Estado</label>
                      <Select
                        value={state}
                        onChange={setState}
                        options={filters.states}
                        menuPortalTarget={document.body}
                        noOptionsMessage={() => "No hay opciones"}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        id="state"
                        className={styles.customSelectHeight}
                        components={{
                          IndicatorSeparator: () => null,
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-5 col-xl-5">
                    <div className="table-search-blk">
                      <div className="form-group local-forms search-icon">
                        <form>
                          <input
                            type="text"
                            className={[
                              styles.backgroundText + " form-control",
                            ]}
                            onChange={searchTextHandle}
                            placeholder="Búsqueda por documento de identificación o nombre"
                          />
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="col-1 col-md-1 col-xl-1 mt-1">
                    <button
                      type="submit"
                      className={
                        advanceMode ? "btn btn-info" : "btn btn-outline-info"
                      }
                      onClick={onClickAdvanceMode}
                      title="Filtros Avanzados"
                    >
                      <i
                        className={
                          advanceMode
                            ? "feather-chevron-down"
                            : "feather-chevron-up"
                        }
                      >
                        <FeatherIcon
                          icon={advanceMode ? "chevron-down" : "chevron-up"}
                        />
                      </i>
                    </button>
                  </div>
                  <div className="col-12 col-md-3 col-xl-3">
                    <div className="doctor-submit">
                      <button
                        type="submit"
                        onClick={onSearch}
                        className="btn btn-primary submit-list-form me-2"
                      >
                        Buscar
                      </button>
                    </div>
                  </div>
                </div>
                {/* End Basic Filters */}
                {/* Advance Mode  */}
                {advanceMode && (
                  <div className="advance-filters">
                    <div className="row">
                      {/* <div className="col-12 col-md-6 col-xl-3">
                        <div className="form-group local-forms">
                          <label>Estado</label>
                          <Select
                            value={state}
                            onChange={setState}
                            options={filters.states}
                            menuPortalTarget={document.body}
                            noOptionsMessage={() => "No hay opciones"}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            id="state"
                            className={styles.customSelectHeight}
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                          />
                        </div>
                      </div> */}
                      <div className="col-12 col-md-6 col-xl-3">
                        <div className="form-group local-forms">
                          <label>Riesgo</label>
                          <Select
                            defaultValue={risk}
                            onChange={setRisk}
                            options={filters.risks}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            id="search-commodity"
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-3">
                        <div className="form-group local-forms">
                          <label>Gestor</label>
                          <Select
                            isMulti
                            defaultValue={manager}
                            onChange={setManager}
                            options={filters.managers}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            id="search-commodity"
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Search Filters */}
      <div className="card card-table">
        <div className="card-body">
          <div className="table-responsive doctor-list">
            {
              <Table
                pagination={{
                  pageSize: datasource.count,
                  total: datasource.pageCount,
                  showTotal: (total, range) =>
                    `Mostrando ${range[0]} de ${range[1]} de ${total} afiliados`,
                  onShowSizeChange: onShowSizeChange,
                  itemRender: itemRender,
                  onChange: onChangePage,
                }}
                columns={columns}
                dataSource={datasource.data}
                rowKey={(record) => record.id}
                locale={{
                  emptyText: loading ? (
                    <Spin size="large" />
                  ) : (
                    <Empty description="No hay datos para mostrar" />
                  ),
                }}
                scroll={{
                  x: 1300,
                }}
              />
            }
          </div>
        </div>
      </div>
      <RegisterPatient
        affiliateData={patientModal}
        open={IsModalOpen}
        onClose={onCloseModal}
        OnCompleteModal={OnCompleteModal}
        options={options}
      />
    </>
  );
};

export default PatientsList;
